import React, { memo } from 'react'
import { useRouter } from 'next/router'
import { useDispatch } from 'react-redux'
import MuiLink from '@mui/material/Link'
import MuiBreadcrumbs from '@mui/material/Breadcrumbs'
import { FormattedMessage, useIntl } from 'react-intl'
import { resetFilters } from 'redux/modules/search'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import sx from './styles'

const Breadcrumbs = ({ sections }) => {
  const router = useRouter()
  const dispatch = useDispatch()
  const { formatMessage: f } = useIntl()
  const handleClick = (item) => {
    dispatch(resetFilters())
    router.push(f({ id: item.href.id }, item.href.values))
  }
  return (
    <Box>
      {sections && sections.length > 0 && (
        <MuiBreadcrumbs
          separator="›"
          sx={sx.root}
          aria-label="breadcrumb"
        >
          {sections.map((item, i) => (
            <MuiLink
              component="button"
              variant="caption"
              key={`breadcrums-${i}`}
              color="inherit"
              onClick={() => handleClick(item)}
              sx={sx.link}
            >
              <Typography
                variant={i > 1 ? 'strong' : 'caption'}
                component="span"
              >
                {item.label.id ? (
                  <FormattedMessage
                    id={item.label.id}
                    values={item.label.values}
                  />
                ) : item.label}
              </Typography>
            </MuiLink>
          ))}
        </MuiBreadcrumbs>
      )}
    </Box>
  )
}

export default memo(Breadcrumbs)
